var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"evolutive","width":'80%',"height":'80%'},on:{"before-open":_vm.load}},[_c('evolutive-modal-content',_vm._b({},'evolutive-modal-content',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }